import { LitElement, html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { ButtonOption } from '../../services/types.js';
import styles from '../../styles/mariana-hierarchy-buttons.css?inline';

/**
 * Multi Button Component
 * Renders up to 3 buttons with fixed position-based styling
 * - Button 1: Red (primary action)
 * - Button 2: Outline (secondary action)
 * - Button 3: Chat background (tertiary/cancel)
 * 
 * Only renders buttons that exist in the array
 */
@customElement('mariana-hierarchy-buttons')
export class MarianaHierarchyButtons extends LitElement {
  static readonly styles = unsafeCSS(styles);

  @property({ type: Array })
  buttons: ButtonOption[] = [];

  @property({ type: Boolean, reflect: true })
  disabled = false;

  private handleClick(button: ButtonOption, index: number) {
    if (this.disabled && index === 0) return;
    this.dispatchEvent(new CustomEvent('button-click', {
      detail: button,
      bubbles: true,
      composed: true,
    }));
  }

  render() {
    if (!this.buttons || this.buttons.length === 0 || this.buttons.length > 3) {
      return html``;
    }

    return html`
      <div class="multi-button-container">
        ${this.buttons.map((button, index) => html`
          <button
            class="button-${index + 1}"
            @click=${() => this.handleClick(button, index)}
            ?disabled=${this.disabled && index === 0}
            type="button"
          >
            ${button.label}
          </button>
        `)}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mariana-hierarchy-buttons': MarianaHierarchyButtons;
  }
}
